module.exports = __webpack_public_path__ + "assets/1e235919579f995bc2ac34f1e73d0055.png";